'use strict';

var loadExternalScript = require('../utils/loadExternalScript');
var loadExternalStyle = require('../utils/loadExternalStyle');
var loginModalPromise;
var loginScriptsPromise;
var loginStylesPromise;
var isOpeningDeferredModal = false;
var isBootstrapLoginModalPatched = false;
var shouldOpenDeferredRegistrationModal = false;
var guestOtpCountdown = null;
var guestOtpRequestInProgress = false;
var outOfStockFailedMessage = $('#outOfStockFailedMessage').val();
var toastMessageHelper = require('../utils/toastMessageHelper');
var wishlistTitle = $('#wishlistTile').val();
var wishlistmsg = $('#wishlistMessage').val();
var inventoryFailedMessage = $('#inventoryFailedMessage').val();
var amountFormatHelper = require('../utils/amountFormatHelper');

/**
 * Loads saved Remember Me credentials from localStorage and prefills login form.
 *
 * @returns {void}
 */
function loadDeferredRememberMeCredentials() {
    var rememberMeEnabled = localStorage.getItem('rememberMeEnabled') === 'true';
    var savedEmail = localStorage.getItem('rememberMeEmail');
    var savedPassword = localStorage.getItem('rememberMePassword');

    if (rememberMeEnabled && savedEmail && savedPassword) {
        $('#login-email').val(savedEmail);
        $('#login-email-password').val(atob(savedPassword));
        $('#rememberMe').prop('checked', true);
    }
}

/**
 * Starts the OTP resend countdown timer for the deferred guest-login flow.
 *
 * @param {string | JQuery} param - Resend trigger selector or element.
 * @param {string | JQuery} timer - Timer display selector or element.
 * @param {string | JQuery} timeWrapper - Wrapper selector or element.
 * @returns {void}
 */
function startDeferredGuestOtpTimer(param, timer, timeWrapper) {
    var defaultDuration = 4 * 60 + 59;
    var timerDisplay = $(timer);
    var configuredDurationRaw = parseInt(timerDisplay.data('otp-timer'), 10);
    var configuredDurationSeconds = null;

    if (configuredDurationRaw > 0) {
        configuredDurationSeconds = configuredDurationRaw;
        if (configuredDurationRaw >= 1000) {
            configuredDurationSeconds = Math.floor(configuredDurationRaw / 1000);
        }
    }

    var duration = (configuredDurationSeconds && configuredDurationSeconds > 0) ? configuredDurationSeconds : defaultDuration;

    if (guestOtpCountdown) {
        clearInterval(guestOtpCountdown);
        guestOtpCountdown = null;
    }

    $(timeWrapper).removeClass('d-none');
    $(timer).removeClass('d-none');
    $(param).addClass('d-none');

    var endTime = Date.now() + duration * 1000;

    /**
     * Updates the countdown display once per second.
     *
     * @returns {void}
     */
    function updateDisplay() {
        var remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
        var min = Math.floor(remaining / 60);
        var sec = remaining % 60;

        timerDisplay.text(
            +(min < 10 ? '0' + min : min)
                + ':'
                + (sec < 10 ? '0' + sec : sec)
        );

        if (remaining <= 0) {
            clearInterval(guestOtpCountdown);
            guestOtpCountdown = null;

            $(timeWrapper).addClass('d-none');
            $(timer).addClass('d-none');
            $(param).removeClass('d-none');
        }
    }

    updateDisplay();
    guestOtpCountdown = setInterval(updateDisplay, 1000);
}

/**
 * Appends or replaces a query-string parameter.
 *
 * @param {string} uri - Original URL.
 * @param {string} key - Query-string key.
 * @param {string|boolean} value - Query-string value.
 * @returns {string} URL with the updated query parameter.
 */
function appendToUrl(uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    }

    return uri + separator + key + '=' + value;
}

/**
 * Hides guest-login validation messages and clears invalid state.
 *
 * @returns {void}
 */
function resetGuestLoginValidationState() {
    $('.login-modal-result, .login-modal-missing-error, .login-modal-customer-exists-error, .login-mobile-country-miss-match-error').addClass('d-none');
    $('#guestLoginInput').removeClass('is-invalid');
}

/**
 * Syncs the guest-login field mode between email and phone.
 *
 * @param {JQuery} $guestInput - Guest login input element.
 * @returns {boolean} True when the current value is treated as an email.
 */
function syncGuestLoginInputState($guestInput) {
    var inputValue = $guestInput.val();
    var cleanValue = inputValue.replace(/[^a-zA-Z0-9@.]/g, '');
    var isEmailInput = /\D/.test(cleanValue);

    resetGuestLoginValidationState();
    $guestInput.val(cleanValue);

    if (cleanValue.length >= 4) {
        if (isEmailInput) {
            $guestInput.attr('name', 'email');
            $('.guest-country-select-wrap').addClass('d-none');
            $guestInput.addClass('w-100').removeClass('w-75 country-code-field');
            $('.guest-password-validation-link').removeClass('d-none');
        } else {
            $guestInput.attr('name', 'phone');
            $('.guest-password-validation-link, .password-validation-link').addClass('d-none');
            $('.guest-country-select-wrap').removeClass('d-none');
            $guestInput.removeClass('w-100').addClass('country-code-field w-75');
        }
    } else {
        $guestInput.attr('name', 'guestLogin');
        $guestInput.addClass('w-100').removeClass('w-75 country-code-field');
        $('.guest-country-select-wrap, .guest-password-validation-link').addClass('d-none');
    }

    return isEmailInput;
}

/**
 * Resets the login modal into the phone-login state used by service links.
 *
 * @returns {void}
 */
function prepareCheckloginState() {
    var $wrap = $('.ckc-login-countrycode-drop-down');
    var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');

    $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
    $defaultOption.addClass('active selected');
    $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
    $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');

    $('.country-select-wrap').addClass('d-none');
    $('#loginInput').addClass('w-100');
    $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
}

/**
 * Resets the login modal into its default login state for top-level sign-in triggers.
 *
 * @param {Object} options - Optional behavior flags.
 * @param {boolean} options.resetWishlistPid - Whether to clear the wishlist redirect marker.
 * @returns {void}
 */
function prepareDefaultLoginState(options) {
    var settings = options || {};
    var $profileModal = $('#profile-menu-modal');
    var $wrap = $('.ckc-login-countrycode-drop-down');
    var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');

    if ($profileModal.hasClass('show')) {
        $profileModal.modal('hide');
    }

    $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
    $defaultOption.addClass('active selected');
    $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
    $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');

    $('.country-select-wrap').addClass('d-none');
    $('#loginInput').addClass('w-100').removeClass('is-invalid');
    $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');

    if (settings.resetWishlistPid) {
        window.localStorage.setItem('wishlistPid', '');
    }
}

/**
 * Opens the login modal in registration mode for promo sign-up CTAs.
 *
 * @returns {void}
 */
function prepareSignupState() {
    prepareDefaultLoginState();
    $('.login-modal-content, .ckc-register-form-content, .register-form-content, .ckc-password-register-content, .ckc-corporate-register-form-content, .ckc-reset-login-password, .ckc-reset-login-password-otp, .ckc-reset-login-email-password').addClass('d-none');
    $('.register-form-content').removeClass('d-none');
    $('.individual-btn').addClass('checked');
    $('.corporate-btn').removeClass('checked');
}

/**
 * Moves any redirect URL stored on the modal shell onto the actual login form
 * once the deferred modal markup is present.
 */
function syncDeferredRedirectState() {
    var $modal = $('#ckc-login-modal');
    var redirectUrl = $modal.attr('data-redirect-url');
    var $form = $modal.find('form').first();

    if (redirectUrl && $form.length) {
        $form.attr('data-redirect', redirectUrl);
    }
}

/**
 * Injects the fetched login modal payload into the existing modal shell.
 *
 * @param {string} html - HTML fragment returned by the controller route.
 */
function renderDeferredLoginModal(html) {
    var $fragment = $('<div>').html(html);
    var $dialog = $fragment.find('.login-modal-fragment-dialog').children().first();
    var $modal = $('#ckc-login-modal');
    var $assetContainer = $('#ckc-login-modal-assets');
    var $assets = $fragment.find('.login-modal-fragment-assets').children();

    if ($dialog.length) {
        $modal.empty().append($dialog);
    }

    if ($assetContainer.length) {
        $assetContainer.empty().append($assets);
    } else if ($assets.length) {
        $modal.after($assets);
    }

    $modal.attr('data-loaded', 'true');
    syncDeferredRedirectState();
}

/**
 * Refreshes Bootstrap's cached modal-dialog reference after the deferred
 * login markup has been injected into the modal shell.
 *
 * @returns {void}
 */
function syncBootstrapLoginModalInstance() {
    var $modal = $('#ckc-login-modal');
    var modalInstance = $modal.data('bs.modal');
    var dialog = $modal.find('.modal-dialog').get(0);

    if (modalInstance && dialog) {
        // Bootstrap caches `.modal-dialog` on first init; for this deferred shell
        // we need to refresh that private reference after injecting the markup.
        // eslint-disable-next-line no-underscore-dangle, dot-notation
        modalInstance['_dialog'] = dialog;
    }
}

/**
 * Shows the verification step inside the hydrated login modal for guest checkout.
 *
 * @param {string} guestInputValue - Email or phone entered in the guest modal.
 * @param {boolean} guestEmail - Whether the input is an email address.
 * @returns {void}
 */
function showDeferredGuestVerificationStep(guestInputValue, guestEmail) {
    $('#ckc-guest-login-modal').modal('hide');
    $('#ckc-guest-login-checkout').val(true);
    syncBootstrapLoginModalInstance();
    $('.login-modal-content, .ckc-register-form-content, .register-form-content, .ckc-password-register-content, .ckc-corporate-register-form-content, .ckc-reset-login-password, .ckc-reset-login-password-otp, .ckc-reset-login-email-password').addClass('d-none');
    $('.login-modal-content, .otp-timer').addClass('d-none');
    $('.verification-modal-content, #resend-otp-container').removeClass('d-none');
    startDeferredGuestOtpTimer('#resend-otp-container', '.timer', '#otpTimer');

    if (guestEmail) {
        $('#formCheck').val(guestInputValue).attr('name', 'email');
    } else {
        $('#formCheck').val(guestInputValue).attr('name', 'phone');
    }

    $('#ckc-login-modal').modal('show');
}

/**
 * Shows the registration step inside the hydrated login modal for guest checkout.
 *
 * @returns {void}
 */
function showDeferredGuestRegistrationStep() {
    $('#ckc-guest-login-modal').modal('hide');
    $('#ckc-guest-login-checkout').val(true);
    syncBootstrapLoginModalInstance();
    $('.login-modal-content, .ckc-register-form-content, .register-form-content, .ckc-password-register-content, .ckc-corporate-register-form-content, .ckc-reset-login-password, .ckc-reset-login-password-otp, .ckc-reset-login-email-password').addClass('d-none');
    $('.login-modal-content').addClass('d-none');
    $('.register-form-content').removeClass('d-none');
    $('.individual-btn').addClass('checked');
    $('.corporate-btn').removeClass('checked');
    $('#guestLoginFormRegisterationSubmit').val(true);
    $('#ckc-login-modal').modal('show');
}

/**
 * Loads the standalone login modal stylesheet on demand.
 *
 * @returns {Promise<void>} Resolves after the stylesheet is available.
 */
function loadDeferredLoginStyles() {
    var $modal = $('#ckc-login-modal');
    var loginModalStyleUrl = $modal.data('loginModalStyleUrl');

    if ($modal.attr('data-styles-loaded') === 'true' || !loginModalStyleUrl) {
        $modal.attr('data-styles-loaded', 'true');
        return Promise.resolve();
    }

    if (loginStylesPromise) {
        return loginStylesPromise;
    }

    loginStylesPromise = loadExternalStyle(loginModalStyleUrl)
        .then(function () {
            $modal.attr('data-styles-loaded', 'true');
        }).catch(function (error) {
            loginStylesPromise = null;
            throw error;
        });

    return loginStylesPromise;
}

/**
 * Loads the standalone login scripts after the modal DOM has been injected.
 *
 * @returns {Promise<void>} Resolves after both scripts are available.
 */
function loadDeferredLoginScripts() {
    var $modal = $('#ckc-login-modal');
    var loginScriptUrl = $modal.data('loginScriptUrl');
    var loginModalScriptUrl = $modal.data('loginModalScriptUrl');

    if (loginScriptsPromise) {
        return loginScriptsPromise;
    }

    loginScriptsPromise = loadExternalScript(loginScriptUrl)
        .then(function () {
            return loadExternalScript(loginModalScriptUrl);
        }).catch(function (error) {
            loginScriptsPromise = null;
            throw error;
        });

    return loginScriptsPromise;
}

/**
 * Fetches the login modal fragment, injects it into the shell, and then
 * loads the modal-specific JavaScript.
 *
 * @returns {Promise<JQuery>} Resolves with the login modal element.
 */
function ensureLoginModalLoaded() {
    var $modal = $('#ckc-login-modal');

    if (!$modal.length) {
        return Promise.resolve($modal);
    }

    if ($modal.attr('data-loaded') === 'true') {
        syncDeferredRedirectState();
        return Promise.all([
            loadDeferredLoginStyles(),
            loadDeferredLoginScripts()
        ]).then(function () {
            return $modal;
        });
    }

    if (loginModalPromise) {
        return loginModalPromise;
    }

    loginModalPromise = new Promise(function (resolve, reject) {
        $.ajax({
            url: $modal.data('fragmentUrl'),
            method: 'GET',
            dataType: 'html',
            success: function (html) {
                renderDeferredLoginModal(html);
                Promise.all([
                    loadDeferredLoginStyles(),
                    loadDeferredLoginScripts()
                ]).then(function () {
                    if ($modal.hasClass('show')) {
                        $modal.trigger('shown.bs.modal');
                    }

                    resolve($modal);
                }).catch(function (error) {
                    loginModalPromise = null;
                    reject(error);
                });
            },
            error: function (xhr, statusText, errorThrown) {
                loginModalPromise = null;
                reject(new Error(errorThrown || statusText || 'Unable to load login modal.'));
            }
        });
    });

    return loginModalPromise;
}

/**
 * Opens the login modal only after the deferred DOM and scripts are ready.
 *
 * @param {Function} beforeShow - Optional callback invoked after the modal is hydrated and before opening.
 * @returns {Promise<JQuery>} Resolves with the login modal element.
 */
function openDeferredLoginModal(beforeShow) {
    var $modal = $('#ckc-login-modal');

    if (!$modal.length) {
        return Promise.resolve($modal);
    }

    if ($modal.attr('data-loaded') === 'true') {
        return Promise.all([
            loadDeferredLoginStyles(),
            loadDeferredLoginScripts()
        ]).then(function () {
            syncBootstrapLoginModalInstance();
            if (typeof beforeShow === 'function') {
                beforeShow($modal);
            }

            $modal.modal('show');
            return $modal;
        });
    }

    if (isOpeningDeferredModal) {
        return loginModalPromise || Promise.resolve($modal);
    }

    isOpeningDeferredModal = true;
    $.spinner().start();

    return ensureLoginModalLoaded().then(function () {
        syncBootstrapLoginModalInstance();
        if (typeof beforeShow === 'function') {
            beforeShow($modal);
        }

        $.spinner().stop();
        isOpeningDeferredModal = false;
        $modal.modal('show');
        return $modal;
    }).catch(function (error) {
        $.spinner().stop();
        isOpeningDeferredModal = false;
        $modal.modal('hide');
        throw error;
    });
}

/**
 * Routes any direct Bootstrap `modal('show')` call for the deferred login
 * modal through the async loader before Bootstrap creates an empty-shell
 * modal instance.
 *
 * @returns {void}
 */
function patchBootstrapLoginModalShow() {
    var originalModal;

    if (isBootstrapLoginModalPatched || !$.fn.modal) {
        return;
    }

    originalModal = $.fn.modal;

    $.fn.modal = function (config) {
        var isLoginModal = this.length === 1 && this[0].id === 'ckc-login-modal';
        var isShowAction = config === 'show'
            || typeof config === 'undefined'
            || (typeof config === 'object' && config && config.show);

        if (isLoginModal && isShowAction && this.attr('data-loaded') !== 'true') {
            openDeferredLoginModal().catch(function () {
                // Failure is already handled in openDeferredLoginModal.
            });
            return this;
        }

        return originalModal.apply(this, arguments);
    };

    $.fn.modal.Constructor = originalModal.Constructor;
    $.fn.modal.noConflict = originalModal.noConflict;
    isBootstrapLoginModalPatched = true;
}

/**
 * Initiates the "Buy Now" process by simulating a click on the 'Buy Now' button if the current page is a product page.
 *
 * @returns {void}
 */
function continuebuynow() {
    const pageDOM = $('.page');
    if ((pageDOM && pageDOM.length && pageDOM.data('action') === 'Product-Show') || (pageDOM && pageDOM.length && pageDOM.data('action') === 'Search-Show') || (pageDOM && pageDOM.length && pageDOM.data('action') === 'Cart-Show')) {
        // Get the specific product ID that was stored when buy now was clicked
        const targetProductId = sessionStorage.getItem('buyNowProductId');
        let buynowBtn;
        if (targetProductId) {
            // Try multiple selectors to find the specific product's add-to-cart button
            buynowBtn = $('button.add-to-cart.buy-now[data-pid="' + targetProductId + '"]');
        }
        // Fallback to first button if specific product not found (for PDP)
        if (!buynowBtn || !buynowBtn.length) {
            buynowBtn = $('button.add-to-cart').first();
        }
        if (buynowBtn && buynowBtn.length) {
            $(buynowBtn).addClass('proceed-checkout').data('authcustomer', true);
            $('body').trigger('product:beforeAddToCart', buynowBtn[0]);
            $(buynowBtn).trigger('click');
            sessionStorage.removeItem('buyNowProductId');
        }
    }
}

/**
 * Updates the login success modal greeting after the deferred assets exist in the DOM.
 */
function setDeferredLoginSuccessGreeting() {
    var customerFirstName = $('.customerFirstname').val();
    var customerLastName = $('.customerLastName').val();

    if (!customerFirstName || !customerLastName) {
        var emptyCartHeading = $('.empty-cart-heading');
        customerFirstName = emptyCartHeading.data('customerfirstname');
        customerLastName = emptyCartHeading.data('customerlastname');
    }

    $('.success-verification-title').text('Hello, ' + customerFirstName + ' ' + customerLastName + '!');
}

var params = new URLSearchParams(window.location.search);
var shouldShowDeferredLoginSuccessModal = false;
var shouldShowDeferredRegistrationSuccessModal = false;
if (params.get('ckcLogin')) {
    if (params.get('ckcTrackOrder')) {
        $('.track-order-footer').first().trigger('click');
        params.delete('ckcTrackOrder');
    } else {
        shouldShowDeferredLoginSuccessModal = true;
    }
    if (window.localStorage.getItem('wishlistPid')) {
        toastMessageHelper.showNotification(wishlistTitle, wishlistmsg, 'wishlistfilledredicon');
        window.localStorage.removeItem('wishlistPid');
    }

    params.delete('ckcLogin');
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.pushState({}, document.title, newUrl);
} else if (params.get('ckcRegister')) {
    shouldShowDeferredRegistrationSuccessModal = true;
    if (window.localStorage.getItem('wishlistPid')) {
        toastMessageHelper.showNotification(wishlistTitle, wishlistmsg, 'wishlistfilledredicon');
        window.localStorage.removeItem('wishlistPid');
    }
    params.delete('ckcRegister');
    var finalUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.pushState({}, document.title, finalUrl);
} else if (params.get('buynow')) {
    continuebuynow();
    params.delete('buynow');
    var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.pushState({}, document.title, url);
} else if (params.get('isRegister')) {
    params.delete('isRegister');
    shouldOpenDeferredRegistrationModal = true;
    var isNotAutheticated = $('#ckc-login-modal').data('nonRegisteredText');
    if (params.get('isNotAutheticated')) {
        toastMessageHelper.showNotification(isNotAutheticated);
    }
    params.delete('isNotAutheticated');
    var loginUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.pushState({}, document.title, loginUrl);
}

if (params.get('inventoryCheckFailed')) {
    toastMessageHelper.showNotification(inventoryFailedMessage);
    params.delete('inventoryCheckFailed');
    var inventoryFailedUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.pushState({}, document.title, inventoryFailedUrl);
}

if (params.get('outOfStockItems')) {
    toastMessageHelper.showNotification(outOfStockFailedMessage);
    params.delete('outOfStockItems');
    var outOfStockFailedUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.pushState({}, document.title, outOfStockFailedUrl);
}

/**
 * Binds deferred login modal event handlers for page-level triggers.
 *
 * @returns {void}
 */
function initLoginModalLoader() {
    var $modal = $('#ckc-login-modal');

    if (!$modal.length) {
        return;
    }
    patchBootstrapLoginModalShow();

    if (shouldOpenDeferredRegistrationModal) {
        openDeferredLoginModal().catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    }

    if (shouldShowDeferredLoginSuccessModal || shouldShowDeferredRegistrationSuccessModal) {
        ensureLoginModalLoaded().then(function () {
            if (shouldShowDeferredLoginSuccessModal) {
                setDeferredLoginSuccessGreeting();
                $('#ckc-success-modal').modal('show');
            }

            if (shouldShowDeferredRegistrationSuccessModal) {
                $('#ckc-registeration-success-modal').modal('show');
            }
        }).catch(function () {
            // Failure is already handled in ensureLoginModalLoaded callers.
        });
    }

    $modal.on('show.bs.modal', function (event) {
        if ($modal.attr('data-loaded') === 'true') {
            return;
        }

        event.preventDefault();
        openDeferredLoginModal().catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    $('body').on('click', '.checklogin', function (event) {
        var isAuthenticated = $('#isAuthenticated').val();
        var $trigger = $(this);
        var href = $trigger.attr('href');

        event.preventDefault();
        event.stopPropagation();

        if (href) {
            localStorage.setItem('pendingCid', href);
        }

        if (isAuthenticated === 'true') {
            window.open(href, '_blank');
            return;
        }

        openDeferredLoginModal(function () {
            prepareCheckloginState();
        }).catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    $('body').on('click', '.loginModalTrigger', function (event) {
        event.preventDefault();
        event.stopPropagation();

        openDeferredLoginModal(function () {
            prepareDefaultLoginState({
                resetWishlistPid: true
            });
        }).catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    $('body').on('click', '#private-category', function (event) {
        if ($('#isAuthenticated').val() === 'true') {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        sessionStorage.setItem('postLoginRedirect', $(this).attr('href'));

        openDeferredLoginModal(function () {
            prepareDefaultLoginState();
        }).catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    $('body').on('click', '.promo-btn-login', function (event) {
        event.preventDefault();
        event.stopPropagation();

        openDeferredLoginModal(function () {
            prepareDefaultLoginState();
        }).catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    $('body').on('click', '.promo-btn-signup', function (event) {
        event.preventDefault();
        event.stopPropagation();

        openDeferredLoginModal(function () {
            prepareSignupState();
        }).catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    $('body').on('input', '#guestLoginInput', function () {
        syncGuestLoginInputState($(this));
    });

    $('body').on('submit', '#guest-login-form', function (event) {
        var $form = $(this);
        var $guestInput = $('#guestLoginInput');
        var guestInputValue;
        var guestEmail;
        var guestEmailValid = false;
        var guestCountryCode;
        var guestLoginData;

        event.preventDefault();

        if (guestOtpRequestInProgress) {
            return;
        }

        guestEmail = syncGuestLoginInputState($guestInput);
        guestInputValue = $guestInput.val();

        if (guestEmail) {
            guestEmailValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(guestInputValue);
        }

        if (!guestEmailValid && guestEmail) {
            $('.login-modal-result').removeClass('d-none');
            $('.login-modal-missing-error, .login-modal-customer-exists-error').addClass('d-none');
            $guestInput.addClass('is-invalid');
            return;
        }

        if (guestInputValue.length < 4) {
            $('.login-modal-result, .login-modal-customer-exists-error').addClass('d-none');
            $('.login-modal-missing-error').removeClass('d-none');
            $guestInput.addClass('is-invalid');
            return;
        }

        guestCountryCode = $('.guest-country-select-wrap .selected-value.active').text();
        $('#guest-selected-country-code').val(guestCountryCode);
        $guestInput.attr('name', guestEmail ? 'email' : 'phone');
        guestLoginData = $form.serialize();
        guestOtpRequestInProgress = true;
        $.spinner().start();

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: guestLoginData,
            success: function (response) {
                if (!response.error) {
                    if (!$('.proceed-to-checkout').val()) {
                        var appendedUrl = appendToUrl(window.location.href, 'buynow', true);
                        window.history.pushState({ segmentVal: '#buynow' }, '', appendedUrl);
                    } else {
                        $('.checout-guest-login').val(true);
                    }

                    ensureLoginModalLoaded().then(function () {
                        $.spinner().stop();
                        showDeferredGuestVerificationStep(guestInputValue, guestEmail);
                        guestOtpRequestInProgress = false;
                    }).catch(function () {
                        $.spinner().stop();
                        guestOtpRequestInProgress = false;
                    });

                    return;
                }

                if ((response.email || response.phone) && response.register) {
                    if (!$('.proceed-to-checkout').val()) {
                        var appendedRegisterUrl = appendToUrl(window.location.href, 'buynow', true);
                        window.history.pushState({ segmentVal: '#buynow' }, '', appendedRegisterUrl);
                    } else {
                        $('.checout-guest-login').val(true);
                    }

                    ensureLoginModalLoaded().then(function () {
                        $.spinner().stop();
                        showDeferredGuestRegistrationStep();
                        guestOtpRequestInProgress = false;
                    }).catch(function () {
                        $.spinner().stop();
                        guestOtpRequestInProgress = false;
                    });

                    return;
                }

                $.spinner().stop();
                $('.login-mobile-country-miss-match-error').removeClass('d-none');
                guestOtpRequestInProgress = false;
            },
            error: function () {
                $.spinner().stop();
                guestOtpRequestInProgress = false;
            }
        });
    });

    $('body').on('click', '.ckc-guest-login-countrycode-drop-down .custom-option-value', function () {
        var $active = $('.ckc-guest-login-countrycode-drop-down .custom-option-value.active');

        if ($active.is(this)) {
            return;
        }

        $('.guest-country-select-wrap').addClass('d-none');
        $('#guestLoginInput').addClass('w-100').removeClass('w-75 country-code-field').val('');
        $('.guest-password-validation-link').addClass('d-none');
    });

    $('body').on('click', '.guest-password-validation-link', function (event) {
        event.preventDefault();

        openDeferredLoginModal(function () {
            var isValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test($('#guestLoginInput').val());

            $('#ckc-guest-login-modal').modal('hide');
            $('.login-modal-content').addClass('d-none');
            $('.email-password-form-content').removeClass('d-none');
            $('#rememberMe').prop('checked', false);
            $('.login-password').attr('type', 'password');
            $('.toggle-password').find('use').attr('xlink:href', '#password-non-visible-symbol');

            if (isValid) {
                $('#login-email').val($('#guestLoginInput').val());
            } else {
                $('#login-email').val('');
            }

            $('#login-email-password').val('');
            $('#ckc-guest-login-checkout').val(true);
            loadDeferredRememberMeCredentials();

            if (!$('.proceed-to-checkout').val()) {
                var appendedUrl = appendToUrl(window.location.href, 'buynow', true);
                window.history.pushState({ segmentVal: '#buynow' }, '', appendedUrl);
            } else {
                $('.checout-guest-login').val(true);
            }
        }).catch(function () {
            // Failure is already handled in openDeferredLoginModal.
        });
    });

    // eslint-disable-next-line consistent-return
    $('body').on('click', '.proceed-to-checkout-btn', function (e) {
        e.preventDefault();
        if ($('#isAuthenticated').val() !== 'true') {
            var actionUrl = $(this).data('action-url');
            $('.proceed-to-checkout').val(true);
            $.spinner().start();
            $.ajax({
                url: actionUrl,
                type: 'GET',
                success: function (response) {
                    $.spinner().stop();
                    $('.login-modal-result, .login-modal-missing-error, .login-modal-customer-exists-error, .login-mobile-country-miss-match-error, .guest-login-modal-subtitle').addClass('d-none');
                    $('.continue-as-guest-section').removeClass('d-none');
                    $('#guestLoginInput').val('');
                    $('#guestLoginInput').addClass('w-100');
                    $('.guest-continue-button').removeAttr('enabled');
                    $('.guest-country-select-wrap').addClass('d-none');
                    var $guestWrap = $('.ckc-guest-login-countrycode-drop-down');
                    $guestWrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
                    var $guestDefaultOption = $guestWrap.find('.custom-option-value[data-id="+91"]');
                    $guestDefaultOption.addClass('active selected');
                    $guestWrap.find('.custom-drop-down-login .selected-value').text($guestDefaultOption.data('id')).addClass('active');
                    if (response.guestLoginMessage) {
                        var $guestSubtitle = $('.guest-login-modal-subtitle');
                        var subtitleTemplate = $guestSubtitle.data('template');

                        if (!subtitleTemplate) {
                            subtitleTemplate = $guestSubtitle.text();
                            $guestSubtitle.data('template', subtitleTemplate);
                        }

                        if (subtitleTemplate && response && response.amount !== null && response.amount !== undefined) {
                            var formattedAmount = amountFormatHelper.formatGuestThresholdAmount(response.amount);
                            $guestSubtitle.text(subtitleTemplate.replace(/\{0\}/g, formattedAmount));
                        }

                        $guestSubtitle.removeClass('d-none');
                        $('.guest-continue-button').attr('disabled', true);
                        $('.continue-as-guest-section').addClass('d-none');
                    }
                    $('#ckc-guest-login-modal').modal('show');
                    $('#cartVouchersModelSection').modal('hide');
                }
            });
            return false;
        }
        if ($(this).attr('href')) {
            // eslint-disable-next-line
            $.spinner().start();
            window.location.href = $(this).attr('href');
        }
    });

    window.ensureLoginModalLoaded = ensureLoginModalLoaded;
}

initLoginModalLoader.ensureLoginModalLoaded = ensureLoginModalLoaded;
initLoginModalLoader.openDeferredLoginModal = openDeferredLoginModal;

module.exports = initLoginModalLoader;
